// ABOUTME: The coaching segment after booking through the Nylas picker: the sessions now booked
// ABOUTME: Mirrors FreeBusy's success panel and copy, listing each session's date and time
import {
  BookingResult,
  browserTimeZone,
  formatTimeRange,
  formatWeekdayDate,
} from '@execonline-inc/slot-picker.private';
import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../Translations';
import * as style from './style.module.css';

interface Props {
  booked: BookingResult[];
  locale: string;
}

// The booking modal closed and this panel replaced its trigger, so focus moves here.
const focusOnMount = (element: HTMLElement | null): void => {
  fromNullable(element).do((el) => {
    el.focus();
  });
};

// Listed in the browser's zone, the one the picker opens in.
const CoachingScheduledView: React.FC<Props> = ({ booked, locale }) => {
  const timeZone = browserTimeZone();

  return (
    <div className={style.success}>
      <h1 ref={focusOnMount} tabIndex={-1} className="outline-none">
        <T kind="Your meeting was successfully scheduled" />
      </h1>
      <ul className="my-4 flex list-none flex-col gap-1 p-0">
        {booked.map((session) => (
          <li key={session.startAt.toISOString()} className="font-semibold text-gray-900">
            {formatWeekdayDate(session.startAt, timeZone, locale)},{' '}
            {formatTimeRange(session.startAt, session.endAt, timeZone, locale)}
          </li>
        ))}
      </ul>
      <p>
        <T kind="Please view the invite sent to your calendar for full details" />
      </p>
      <p>
        <T kind="Please note, you may come back to this segment ..." />
      </p>
    </div>
  );
};

export default observer(CoachingScheduledView);
